export default {
    account: 'Account',
    activationFailed: 'Something went wrong when activating your e-mail!',
    sidebar: {
        dashboard: 'User profile',
        company: 'Company details',
        password: 'Password',
        todo: 'To-do list',
        tags: 'Tags',
        subscription: 'Subscription & renewal',
        printTemplates: 'Print templates',
        noteTemplates: 'Note templates',
        questionnaires: 'Questionnaires',
        serial: 'Serial no.',
        sms: 'SMS settings'
    },
    profile: {
        nonActivatedEmail: 'You have not confirmed your e-mail.',
        missingPhone: 'Please complete your phone number for easier communication!',
        edit: 'Edit Profile',
        resendActivation: 'Re-send confirmation e-mail',
        emailActivationError: 'Something went wrong with confirming your e-mail!',
        uploadLogo: {
            title: 'Logo',
            subtitle: 'Upload your logo (used in printing etc.)'
        },
        addRemoveImage: 'Add / remove image',
        user: {
            title: 'User details',
            subtitle: 'Edit your base information & social media',
            insertYour: 'Insert your {field}',
            insertYourShe: 'Insert your {field}',
            insertYourSheN: 'Insert your {field}',
            bio: 'Bio',
            social: {
                title: 'Social media',
                website: 'Website',
                facebook: 'Facebook',
                instagram: 'Instagram',
                twitter: 'Twitter',
                linkedin: 'LinkedIn'
            }
        }
    },
    imageUpload: {
        profileImage: 'Profile picture',
        hint: 'Drop an image or click here to select',
        onlyImg: 'Please insert an image',
        outOfSize: 'Image is larger than the size limit: ',
        lowestPx: 'Image is too small. Expected size: '
    },
    company: {
        title: 'Company details',
        subtitle: 'Insert your company\'s details',
        company: 'Company name',
        companyPlaceholder: 'Insert your company\'s name',
        occupation: 'Occupation',
        vat: 'VAT',
        doy: 'DOY (optional)'
    },
    changePassword: {
        title: 'Change password',
        subtitle: 'Change your current password',
        password: 'Current password',
        newPassword: 'New password',
        placeholders: {
            password: 'Insert your current password',
            repeatPassword: 'Repeat your new password.',
            newPassword: 'Insert your new password.',
        },
        passwordsNoMatch: 'Passwords don\'t match.',
        minLength: 'At least {min} characters.',
        save: 'Change password'
    },
    tags: {
        title: 'Tags',
        subtitle: 'Manage all your tags',
        athlete: 'Client tags',
        dietPlans: 'Diet plan tags',
        templates: 'Meal template tags',
        recipes: 'Recipe tags',
        edit: 'Edit tag',
        name: 'Tag name',
        empty: 'No tags in this category'
    },
    subscriptions: {
        title: 'Subscription info',
        subtitle: 'Information about your subscription & renewal',
        instalmentExpiry: 'You have {days} days to pay your next instalment!',
        instalmentOverdue: 'Your instalment payment window has expired.',
        cost: 'Yearly renewal cost: 149,90€ + VAT',
        daysUntil: 'Days until next renewal:',
        remaining: 'There are {days} days remaining',
        pay: 'Pay',
        renew: 'Renew yearly subscription',
        statuses: {
            COMPLETED: 'Completed',
            PENDING: 'Pending payment'
        },
        remainingLong: '<p>There are <strong>{days} days</strong> until the next renewal</p>',
        expired: '<p>Your subscription expired on <strong>{date}</strong></p>'
    },
    history: {
        title: 'Transaction history',
        subtitle: 'View all your transactions',
        amount: 'Amount',
        doses: 'Instalments',
        due: 'Due date',
        pay: 'Pay',
        payNow: 'Pay now',
        status: 'Status',
        pending: 'Upcoming payment',
        completed: 'Completed',
        payNextRenewal: 'Pay upcoming renewal',
        payUntil: 'Pay until {date}',
        type: {
            title: 'Transaction type',
            PURCHASE: 'Software purchase',
            RENEW: 'Yearly renewal',
            PURCHASE_INSTALMENT: 'Purchase instalment'
        },
        empty: {
            title: 'No transactions',
            subtitle: 'Your payments will show up here.'
        }
    },
    sms: {
        title: 'SMS Settings',
        subtitle: 'Manage your SMS subscription and usage history',
        comingSoon: {
            title: 'Coming Soon',
            subtitle: 'SMS functionality will be available soon. Stay tuned!'
        },
        subscription: {
            title: 'SMS Subscription',
            subtitle: 'Manage your SMS subscription and usage',
            status: 'Status',
            statusActive: 'Active',
            period: 'Period',
            startDate: 'Start date',
            endDate: 'End date',
            manageSubscription: 'Manage Subscription',
            createSubscription: 'Create Subscription',
            tabs: {
                details: 'Details'
            },
            empty: {
                title: 'No active subscription',
                subtitle: 'Create an SMS subscription to get started'
            },
            marketing: {
                title: 'SMS Appointment Reminders',
                subtitle: 'Automatically send reminders to your customers 24 hours before their next appointment',
                cta: 'Enable SMS Reminders',
                previewTitle: 'Message Preview',
                previewRecipient: 'Customer',
                sampleMessage: 'Hello! This is a sample SMS reminder for your appointment.'
            }
        },
        faq: {
            title: 'Frequently Asked Questions',
            items: {
                howItWorks: {
                    question: 'How does the SMS service work?',
                    answer: 'The SMS service automatically sends reminders to your customers 24 hours before their next appointment. You can customize the timing (default: 24 hours).'
                },
                pricing: {
                    question: 'What is the subscription pricing?',
                    answer: 'The SMS subscription offers a specific number of SMS per period. For more information about pricing, visit the Stripe portal.'
                },
                cancel: {
                    question: 'How can I cancel my subscription?',
                    answer: 'You can manage or cancel your subscription through the Stripe portal by clicking the "Open Stripe Portal" button.'
                },
                usage: {
                    question: 'What happens if I exceed my SMS limit?',
                    answer: 'If you exceed your period SMS limit, you will need to renew your subscription or wait for the next period.'
                }
            }
        },
        usage: {
            title: 'SMS Usage',
            currentPeriod: 'Current period',
            used: 'Used',
            planned: 'Planned',
            remaining: 'Remaining',
            of: 'of',
            sms: 'SMS',
            noUsage: 'No usage this period',
            exceeded: {
                title: 'SMS Limit Exceeded',
                message: 'Your current usage plus scheduled SMS exceeds your plan limit. Some scheduled SMS may not be sent.'
            },
            tooltips: {
                used: 'SMS that have been sent already',
                planned: 'SMS scheduled for the current billing period (not for future months)'
            },
            threshold: {
                error: {
                    message: 'You have more scheduled + sent SMS for the period than your available. That will make some SMS reminders fail to send. '
                },
                cta: 'Upgrade your plan now'
            }
        },
        history: {
            title: 'Usage History',
            subtitle: 'Previous periods',
            period: 'Period',
            used: 'Used',
            empty: {
                title: 'No history',
                subtitle: 'No previous periods found'
            }
        },
        scheduled: {
            title: 'SMS',
            subtitle: 'Scheduled, sent and failed SMS',
            tabs: {
                scheduled: 'Scheduled SMS',
                sent: 'Sent SMS',
                failed: 'Failed SMS'
            },
            comingSoon: 'Coming soon',
            empty: {
                future: {
                    title: 'No messages found',
                    subtitle: 'No scheduled SMS found in the future'
                },
                failed: {
                    title: 'No messages found',
                    subtitle: 'No failed SMS found'
                },
                sent: {
                    title: 'No messages found',
                    subtitle: 'No SMS has been sent yet'
                }
            },
            table: {
                message: 'Message',
                segments: '{count} SMS',
                error: 'Error',
                retries: 'Retries',
                status: {
                    sent: 'Sent',
                    failed: 'Failed',
                    scheduled: 'Scheduled',
                    pending: 'Pending'
                }
            }
        },
        settings: {
            title: 'SMS Settings',
            subtitle: 'Manage your SMS reminder settings',
            enable: {
                title: 'Enable SMS Reminders',
                description: 'Automatically send SMS reminders for each appointment that is created'
            },
            reminder: {
                title: 'Reminder Settings',
                description: 'Configure when reminders will be sent before appointments',
                hoursBefore: 'Hours before appointment'
            },
            messageTemplate: {
                title: 'Message text',
                description: 'The text your customers receive. {date} and {time} become the appointment\'s date and time.',
                insert: 'Insert:',
                placeholders: {
                    date: 'Date',
                    time: 'Time'
                },
                reset: 'Reset to default',
                counter: '{length}/{limit} characters · {segments} SMS per reminder',
                multiPart: 'The text is longer than {chars} characters, so each reminder uses {segments} SMS from your plan.',
                applyToScheduled: 'Also update the scheduled reminder | Also update the {count} scheduled reminders',
                applyCost: 'They will use {after} SMS in total instead of {before}.',
                keepScheduled: 'Reminders already scheduled keep the previous text unless the appointment is changed.',
                errors: {
                    EMPTY: 'Write the reminder text.',
                    MISSING_PLACEHOLDER: 'The text must include the appointment date and time.',
                    HAS_LINK: 'Remove the link; reminders can\'t contain links.',
                    TOO_LONG: 'Shorten the text to fit in {max} SMS ({chars} characters).'
                },
                confirm: {
                    title: 'Each reminder will use {segments} SMS',
                    body: 'The new text is longer than the {chars} characters of one SMS, so from now on each reminder uses {segments} SMS from your plan.',
                    ok: 'Save'
                }
            },
            hours: 'hours'
        }
    }

}
